import { Link, useLocation } from "react-router-dom"
import {DashboardIcon, InvestmentProfilesIcon, CompaniesIcon, DealRoomIcon, LearningIcon, ContactUsIcon, WatchlistIcon} from './images/MenuIcons';
import cx from 'classnames';
import { BrandLogo } from "./components/BrandLogo";

const MenuGroup = ({title, items, onClick}) => {
    const location = useLocation();
    const handleClick = () => {
        onClick()
    }
    return (
        <div className="space-y-1">
            {title && <div className="px-3 pb-2 pt-5 text-xs font-semibold uppercase tracking-[0.12em] text-slate-400">{title}</div>}
            {items.map((item, index) => {
                const active = location.pathname === item.path || location.pathname.startsWith(item.path + "/");

                return (
                    <Link
                        key={index}
                        to={item.path}
                        onClick={handleClick}
                        className={cx(
                            "flex items-center gap-3 rounded-md px-3 py-3 text-sm font-semibold transition",
                            active
                                ? "bg-[#0f8f4f] text-white shadow-sm"
                                : "text-slate-600 hover:bg-emerald-50 hover:text-slate-950"
                        )}
                    >
                        {active ? item.iconActive : item.icon}
                        <span className="truncate">{item.title}</span>
                    </Link>
                )
            })}
        </div>
    )
}

export const LeftMenu = ({onClick}) => {

    const menuItems1 = [
        {icon: <DashboardIcon fill="general-70" />, iconActive: <DashboardIcon fill="white"/>, path: "/dashboard", title: "My Dashboard"},
        {icon: <InvestmentProfilesIcon fill="general-70"/>, iconActive: <InvestmentProfilesIcon fill="white"/>, path: "/investment_profiles", title: "Investment Profiles"},
        {icon: <CompaniesIcon fill="general-70" />, iconActive: <CompaniesIcon fill="white"/>, path: "/companies", title: "Companies"},
        {icon: <WatchlistIcon fill="general-70"/>, iconActive: <WatchlistIcon fill="white"/>, path: "/watchlist", title: "Watch List"},
        {icon: <DealRoomIcon fill="general-70"/>, iconActive: <DealRoomIcon fill="white"/>, path: "/deal_room", title: "Deal Room"},
    ]

    const menuItems2 = [
        {icon: <LearningIcon fill="general-70" />, iconActive: <LearningIcon fill="white" />, path: "/learning", title: "Learning"},
        {icon: <ContactUsIcon fill="general-70" />, iconActive: <ContactUsIcon fill="white" />, path: "/contactus", title: "Contact Us"},
    ]

    const handleClick = () => {
        onClick()
    }
    return (
        <nav className="flex h-full flex-col bg-white px-4 py-5">
            <div className="mb-5 border-b border-slate-200 pb-5 lg:hidden">
                <BrandLogo/>
            </div>

            <MenuGroup title="Workspace" items={menuItems1} onClick={handleClick}/>

            <div className="mt-auto rounded-md border border-emerald-100 bg-emerald-50/70 p-4">
                <p className="text-xs font-semibold uppercase tracking-[0.12em] text-emerald-700">Research flow</p>
                <p className="mt-2 text-sm font-medium leading-5 text-slate-700">
                    Search, compare, monitor, and review company signals from one workspace.
                </p>
            </div>

            <MenuGroup title="Support" items={menuItems2} onClick={handleClick}/>
        </nav>
    )
}
